import { Button } from '@mui/material';

const ButtonStyled = ({text, primary=true, customStyle, handleClick, isDisabled}) => {
    return (
      <Button
        disabled={isDisabled}
        variant='contained'
        onClick={handleClick}
        sx={{ 
          fontSize: '0.875rem',
          fontWeight:'700',
          backgroundColor: primary ? '#FC581F' : '#FFF',
          color: primary ? '#FFF' : '#303030',
          textTransform:'none',
          minWidth: {xs: 0,lg: '64px'},
          padding:'1.125rem 2rem;',
          borderRadius:'0.25rem',
          boxShadow: '1px 1px 4px 0px rgba(0, 0, 0, 0.10), 0px 0px 1px 0px rgba(0, 0, 0, 0.10)',
          '&:hover': { 
            backgroundColor: primary ? '#FC581F' : '#FFF'
          },
          ...customStyle
        }}
      >
        {text}
      </Button>
    )
  }
  
  export default ButtonStyled